import { InitialState } from "./type";

export const initialState: InitialState = {
  categoryList: [],
};
